module.exports = __webpack_public_path__ + "img/dtu-suda.52a1d006.png";